import { useRef, useEffect } from 'react';

export default function useInterval(callback, delay) {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  });

  useEffect(() => {
    if (delay) {
      const intervalId = setInterval(() => savedCallback.current(), delay);

      return () => clearInterval(intervalId);
    }
  }, [delay]);
}
